import React from 'react';
import styles from './vk-integration.module.scss';

const CLIENT_EVENTS = [
  'Подтверждение записи',
  'Напоминание о визите',
  'Изменение услуги или сотрудника',
  'Перенос даты или времени',
  'Отмена записи',
];

const BUSINESS_EVENTS = [
  'Новая запись клиента',
  'Изменение услуги или сотрудника',
  'Перенос записи',
  'Отмена записи',
];

export const VkIntegration: React.FC = () => {
  return (
    <div className={styles.vk_outer}>
      <div className={styles.vk_inner}>
        <h2 className={styles.vk_title}>
          VK-боты: управление записью и уведомления
        </h2>

        <div className={styles.vk_cards}>
          <div className={styles.vk_card}>
            <div className={styles.card_title}>
              <span className={styles.card_icon}>
                <svg viewBox="0 0 24 24" width="26" height="26" fill="none">
                  <path
                    d="M12.77 17.29c-5.47 0-8.59-3.75-8.72-9.99h2.74c.09 4.58 2.11 6.52 3.71 6.92V7.3h2.58v3.95c1.58-.17 3.24-1.97 3.8-3.95h2.58c-.43 2.44-2.23 4.24-3.51 4.98 1.28.6 3.33 2.17 4.11 5.01h-2.84c-.61-1.9-2.13-3.37-4.14-3.57v3.57z"
                    fill="white"
                  />
                </svg>
              </span>
              Клиентский бот
            </div>
            <div className={styles.card_subtitle}>
              Клиент получает уведомления прямо в VK
            </div>
            <ul className={styles.card_list}>
              {CLIENT_EVENTS.map((event) => (
                <li key={event} className={styles.card_list_item}>
                  <svg
                    className={styles.check_icon}
                    width="14"
                    height="11"
                    viewBox="0 0 14 11"
                    fill="none"
                  >
                    <path
                      d="M1 5.5L4.5 9.5L13 1"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  {event}
                </li>
              ))}
            </ul>
            <div className={styles.card_footer}>
              Может подтвердить, перенести или отменить запись прямо в чате с
              ботом
            </div>
          </div>

          <div className={styles.vk_card}>
            <div className={styles.card_title}>
              <span className={styles.card_icon}>
                <svg viewBox="0 0 24 24" width="26" height="26" fill="none">
                  <path
                    d="M12.77 17.29c-5.47 0-8.59-3.75-8.72-9.99h2.74c.09 4.58 2.11 6.52 3.71 6.92V7.3h2.58v3.95c1.58-.17 3.24-1.97 3.8-3.95h2.58c-.43 2.44-2.23 4.24-3.51 4.98 1.28.6 3.33 2.17 4.11 5.01h-2.84c-.61-1.9-2.13-3.37-4.14-3.57v3.57z"
                    fill="white"
                  />
                </svg>
              </span>
              Бизнес-бот
            </div>
            <div className={styles.card_subtitle}>
              Вы получаете уведомления о всех действиях
            </div>
            <ul className={styles.card_list}>
              {BUSINESS_EVENTS.map((event) => (
                <li key={event} className={styles.card_list_item}>
                  <svg
                    className={styles.check_icon}
                    width="14"
                    height="11"
                    viewBox="0 0 14 11"
                    fill="none"
                  >
                    <path
                      d="M1 5.5L4.5 9.5L13 1"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  {event}
                </li>
              ))}
            </ul>
            <div className={styles.card_footer}>
              Вся история операций в одном чате
            </div>
          </div>
        </div>

        <div className={styles.vk_note}>
          Всё бесплатно и безлимитно. Боты работают сразу после подключения
          VK-бота точки.
        </div>
      </div>
    </div>
  );
};
